export const LIGHT_THEME = 'light'
export const DARK_THEME = 'dark'
export const THEME_STORAGE_KEY = 'theme'

export function getInitialTheme() {
  try {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY)
    return savedTheme === DARK_THEME ? DARK_THEME : LIGHT_THEME
  } catch {
    return LIGHT_THEME
  }
}

export function saveTheme(theme) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme)
  } catch (error) {
    console.warn('Не удалось сохранить тему', error)
  }
}

export function applyThemeToDocument(theme) {
  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme
}
